








































import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator'
import ServerError from '@/utils/server_error'
import { getModule } from 'vuex-module-decorators'
import memberStore from '@/modules/member/member.store'
import paymentStore from '@/modules/payment/payment.store'
import { MemberPaymentTransaction, TransactionState } from '@/api/payment'

@Component
export default class WalletTransactions extends Vue {
  memberModule = getModule(memberStore, this.$store)
  paymentModule = getModule(paymentStore, this.$store)

  isLoading: boolean = true

  // Transaction data
  page: number = 1
  pageCount: number = 1

  headers: any[] = []

  /* Hooks */
  async mounted() {
    this.headers = [
      {
        text: this.$t('WalletTransactions.Date'),
        value: 'date'
      },
      {
        text: this.$t('WalletTransactions.Remark'),
        value: 'remark',
        sortable: false
      },
      {
        text: this.$t('WalletTransactions.Status'),
        value: 'status',
        sortable: false
      },
      {
        text: this.$t('WalletTransactions.Amount'),
        value: 'amount',
        sortable: false
      }
    ]

    await this.getPaymentTransaction()
  }

  /* Methods */
  async getPaymentTransaction() {
    await this.paymentModule.getPaymentTransaction(this.page)
    this.isLoading = false
  }

  getTransactionStateColor(state: TransactionState) {
    switch (state) {
      case TransactionState.Pending:
      case TransactionState.RefundPending:
        return 'blue'
      case TransactionState.Approved:
      case TransactionState.Completed:
      case TransactionState.Refunded:
        return 'green darken-2'
      default:
        return 'grey darken-3'
    }
  }
  /* Computed Properties */
  get transactions(): MemberPaymentTransaction[] | null {
    return this.paymentModule.transactions
  }

  get transactionsPageCount(): number {
    return this.paymentModule.transactionsPageCount
  }

  get totalTransactions(): number {
    return this.paymentModule.transactionsTotal
  }
}
